import React from "react";
import PropTypes from "prop-types";
import {graphql, Link} from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Button from "../../../components/Button/ButtonV2";
import naniCS from "../../../assets/case-studies/Case Study - Nani.pdf";
import usacleanCS from "../../../assets/case-studies/Case Study - USA Clean.pdf";
import resultsSlides from "../../../assets/images/verticals/resultsSlides.gif";
import Layout from "../../../components/layout";
import {SeoProxy} from "../../../components/seoProxy";

export default function LcmVertical({
  data: {
    wpPage,
    heroImage,
    chessPieces,
    maze,
    binosHand,
    laptopHands,
    shakingHands,
    modernWorkplace,
    clutchBadges,
    greyLaptopCreditCard,
    greyLaptopHands,
    greyLaptopUi,
    greyMonitor,
    greyWorkers,
    handsPhone,
    socialProofBanner,
    lewisTestimonial,
    reviewer,
    reviewer2,
    reviewer3,
    greyPhoneUser,
  },
}) {
  // Images
  const heroImageGet = getImage(heroImage);
  const mazeGet = getImage(maze);
  const chessPiecesGet = getImage(chessPieces);
  const binosHandGet = getImage(binosHand);
  const laptopHandsGet = getImage(laptopHands);
  const shakingHandsGet = getImage(shakingHands);
  const modernWorkplaceGet = getImage(modernWorkplace);
  const clutchBadgesGet = getImage(clutchBadges);
  const greyLaptopCreditCardGet = getImage(greyLaptopCreditCard);
  const greyLaptopHandsGet = getImage(greyLaptopHands);
  const greyLaptopUiGet = getImage(greyLaptopUi);
  const greyMonitorGet = getImage(greyMonitor);
  const greyWorkersGet = getImage(greyWorkers);
  const handsPhoneGet = getImage(handsPhone);
  const socialProofBannerGet = getImage(socialProofBanner);
  const lewisTestimonialGet = getImage(lewisTestimonial);
  const reviewerGet = getImage(reviewer);
  const reviewer2Get = getImage(reviewer2);
  const reviewer3Get = getImage(reviewer3);
  const greyPhoneUserGet = getImage(greyPhoneUser);

  // Year
  const currentYear = new Date().getFullYear();

  // Custom Styles
  const footerBg = `
    footer {
      background: #1b1c1c;
    }
  `;

  const heroImgs = `
  .hero-img-mb {
      display: none !important;
  }

  @media screen and (max-width: 1024px) {
      .hero-img-mb {
          display: block !important;
      }

      .hero-img-dt {
          display: none !important;
      }
  }  
`;

  return (
    <Layout>
      <SeoProxy post={wpPage} />
      {/*** LP Header 
      <div className="w-full relative overflow-hidden bg-black">
        <section className="py-4 md:py-2">
          <div className="container">
            <div className="max-w-[1100px] mx-auto flex items-center justify-between">
                <div className="relative max-w-[120px] md:max-w-[initial]">
                    <GatsbyImage
                        className={`relative`}
                        image={logoImageGet}
                        alt="Disruptive Advertising"
                    />
                </div>
                <div className="relative">
                    <a href="/contact/" className="block decoration-none px-4 py-2 sm:px-8 md:px-12 md:py-3 bg-blue-500 text-white font-bold rounded-full border-white border-1 hover:bg-white hover:text-black">CONTACT US</a>
                </div>
            </div>
          </div>
        </section>
      </div>
      ***/}

      {/*** Hero ***/}
      <div className="w-full relative bg-black z-[9]">
        <section className="py-12 lg:pt-24 lg:pb-0">
          <div className="container z-10">
            <div className="max-w-[1100px] mx-auto items-end md:flex lg:items-end md:justify-between">
                <div className="relative w-full lg:w-[49%] block rounded-lg mb-6 md:mb-0">
                    <h1 className="text-6xl uppercase mb-6 font-bold font-[Antonio] text-white whitespace-normal lg:whitespace-nowrap lg:text-[5.6rem]"><span className="text-disruptive-red">BOOST REVENUE AND <br className="hidden lg:block"/>RETENTION</span> WITH THE <br className="hidden lg:block"/>BEST LIFECYCLE <br className="hidden lg:block"/>MARKETING AGENCY</h1>
                    <p className="text-white mb-8">Most businesses chase new customers, but the real growth comes from keeping the ones you already have. Our free lifecycle marketing audit will show you exactly where you‘re leaving money on the table and how to fix it—whether you work with us or not.</p>
                    <GatsbyImage
                      className={`hero-img-mb relative max-w-[420px] block mx-auto mb-6 lg:mx-0 lg:hidden`}
                      image={heroImageGet}
                      alt="Target with arrows"
                    />
                    <div className="text-center lg:text-left">
                        <Button
                            className={`rounded-full overflow-hidden bg-disruptive-red text-white border-2 border-disruptive-red text-center font-bold xs:tracking-normal mb-12 md:mb-0 hover:bg-transparent hover:text-disruptive-red lg:mb-24`}
                            href={'#lead-form'}
                            color={""}
                            bordered={false}
                        >
                            GET YOUR FREE AUDIT
                        </Button>
                    </div>
                </div>
                <div className="hero-img-dt relative flex justify-start lg:w-[38%] lg:mb-[150px]">
                  <GatsbyImage
                      className={`relative overflow-visible`}
                      image={heroImageGet}
                      alt="Disruptive employees"
                  />
                </div>
            </div>
          </div>
          <style dangerouslySetInnerHTML={{__html: heroImgs}} />
        </section>
      </div>

      {/*** Social Proof ***/}
      <div className="w-full relative overflow-hidden bg-white">
        <section className="py-10">
          <div className="container">
            <div className="max-w-[1100px] mx-auto">
              <GatsbyImage
                className={`relative md:min-w-[544px]`}
                image={socialProofBannerGet}
                alt="Money pile"
              />
            </div>
          </div>
        </section>
      </div>

      {/*** What do you get ***/}
      <div className="w-full relative overflow-hidden bg-[#e7e7e7]">
        <section className="py-8">
          <div className="container z-10">
            <div className="max-w-[1100px] mx-auto md:flex md:items-start md:justify-between">
                <div className="relative w-full md:w-[48%] block rounded-lg mb-6 md:mb-0">
                    <h2 className="text-3xl mb-6 font-bold font-[Antonio] max-w-sm md:text-5xl">WHAT DO YOU GET WITH OUR <span className="text-disruptive-red">LCM MARKETING</span> AUDIT?</h2>
                    <p className="mb-4">Our lifecycle marketing audit is a full breakdown of your current strategy, showing you where you‘re losing customers, missing engagement, and leaving revenue untapped.</p>
                    <p className="text-xl font-bold mb-4">This is the incredible value you’ll get when you call us today:</p>
                    <ol className="mb-4 list-decimal pl-8">
                      <li className="mb-4"><strong>Uncover the Gaps in Your Lifecycle Marketing Strategy:</strong> We analyze your email marketing and lead nurture tactics to pinpoint gaps and missed opportunities.</li>
                      <li className="mb-4"><strong>Build a Strategy for Higher Retention & Revenue:</strong> We’ll map out a plan that keeps customers coming back and increases lifetime value.</li>
                      <li className="mb-4"><strong>Align Your Marketing with Real Business Growth:</strong> Forget vanity metrics. We make sure every lifecycle marketing effort ties directly to your bottom line—so you’re not just getting clicks, you’re getting customers who stick around.</li>
                    </ol>
                </div>
                <div className="relative w-full md:w-[48%] flex justify-center flex-col items-center">
                  <div className="bg-black rounded-[25px] p-12">
                    <div className="flex items-center mb-2">
                        <div>
                            <GatsbyImage
                                className={`relative mr-2`}
                                image={lewisTestimonialGet}
                                alt="review portrait"
                            />
                        </div>
                        <p className="text-white font-bold">Trevor, Marketing Manager</p>
                    </div>
                    <p className="text-white mb-12">“Disruptive’s consistency has been their biggest draw. We’ve seen consistent results.”</p>
                    <div className="rounded-[10px] overflow-hidden border-white border-2">
                        <img src={resultsSlides} alt="results slides" />
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </section>
      </div>

      {/*** Testimonials ***/}
      <div className="w-full relative overflow-hidden bg-white">
        <section className="py-14">
          <div className="container z-10">
            <h2 className="text-3xl mb-14 font-bold font-[Antonio] max-w-[700px] mx-auto text-center md:text-5xl">OUR <span className="text-disruptive-red">LIFECYCLE MARKETING AGENCY</span> HAS HELPED OTHER BUSINESS OWNERS AND MARKETING LEADERS JUST LIKE YOU</h2>
            <div className="max-w-[1100px] mx-auto md:flex items-stretch md:justify-between">
              <div className={String.raw`relative w-full block mb-12 bg-[#e7e7e7] p-8 drop-shadow-lg before:absolute before:content-['\"\"'] before:font-[Antonio] before:text-7xl before:-top-[20px] md:w-[31%] md:mb-0`}>
                <div className="text-center mb-2">
                    <GatsbyImage
                        className={`relative`}
                        image={reviewer3Get}
                        alt="review portrait"
                    /> 
                </div>
                <p className="mb-4">“The communication with Disruptive has been top-notch. They are entirely pressure-free and respectful. The company has earned their stellar reputation.”</p>
                <p className="font-bold">- Jennifer, Marketing Manager</p>
              </div>
              <div className={String.raw`relative w-full block mb-12 bg-[#e7e7e7] p-8 drop-shadow-lg before:absolute before:content-['\"\"'] before:font-[Antonio] before:text-7xl before:-top-[20px] md:w-[31%] md:mb-0`}>
                <div className="text-center mb-2">
                    <GatsbyImage
                        className={`relative`}
                        image={reviewer2Get}
                        alt="review portrait"
                    />
                </div>
                <p className="mb-4">“We have constantly raised the bar and every time they have met it if not went above and beyond.”</p>
                <p className="font-bold">- Brian, Owner & CEO</p>
              </div>
              <div className={String.raw`relative w-full block bg-[#e7e7e7] p-8 drop-shadow-lg before:absolute before:content-['\"\"'] before:font-[Antonio] before:text-7xl before:-top-[20px] md:w-[31%] md:mb-0`}>
                <div className="text-center mb-2">
                <GatsbyImage
                        className={`relative`}
                        image={reviewerGet}
                        alt="review portrait"
                    />
                </div>
                <p className="mb-4">“Anecdotally, they’ve been a really great partner, and the metrics have been in line with the goal we set out for them.”</p>
                <p className="font-bold">- Priscilla, Senior Digital Marketing</p>
              </div>                
            </div>
          </div>
        </section>
      </div>

      {/*** Execution ***/}
      <div className="w-full relative overflow-hidden bg-[#e7e7e7] z-10">
        <section className="py-12">
          <div className="container z-10">
            <div className="max-w-[1100px] mx-auto items-end md:flex lg:items-start md:justify-between">
                <div className="relative w-full md:w-[48%] block rounded-lg mb-6 md:mb-0">
                  <h2 className="text-3xl mb-4 font-bold font-[Antonio] text-disruptive-red md:text-5xl">EXECUTION:</h2>
                    <p className="font-bold uppercase text-lg md:text-2xl mb-4 max-w-md">MOST BUSINESSES COME TO US WITH AN EXECUTION PROBLEM</p>
                    <p className="mb-8 max-w-md">Your emails aren’t converting. SMS messages aren’t getting responses. Your customer journeys are full of gaps, and automation isn’t working the way you expected. It’s easy to assume the problem is execution; your campaigns just need to be “better.” But in reality, execution problems are almost always a symptom of deeper issues.</p>
                    <p className="mb-8 max-w-md">We audit your existing LCM marketing efforts to find leaks in your funnel, then optimize messaging, automation, and segmentation to deliver the right message at the right time.</p>
                </div>
                <div className="relative w-full md:w-[48%]">
                  <GatsbyImage
                      className={`relative`}
                      image={mazeGet}
                      alt="maze"
                  />
                </div>
            </div>
          </div>
        </section>
      </div>

      {/*** Strategy ***/}
      <div className="w-full relative bg-white z-20">
        <section className="py-12">
          <div className="container z-10">
            <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row lg:items-start md:justify-between">
                <div className="relative w-full order-2 md:order-[initial] md:-mt-32 md:w-[48%]">
                  <GatsbyImage
                      className={`relative`}
                      image={chessPiecesGet}
                      alt="chess pieces"
                  />
                </div>
                <div className="relative w-full md:w-[48%] block rounded-lg">
                  <h2 className="text-3xl mb-4 font-bold font-[Antonio] text-disruptive-red md:text-5xl">STRATEGY:</h2>
                    <p className="font-bold uppercase text-lg md:text-2xl mb-4 max-w-md">MOST BRANDS STRUGGLE TO CONNECT BUSINESS GOALS TO SOUND MARKETING STRATEGY</p>
                    <p className="mb-8 max-w-md">You’re running email and SMS marketing campaigns, but they feel disconnected from your larger business goals. You know lifecycle marketing should be driving revenue, but instead, it feels like a box you’re checking. Without a clear strategy, you’re leaving money on the table.</p>
                    <p className="mb-8 max-w-md">We align your email, SMS, and customer retention efforts with business objectives, whether that’s increasing repeat purchases, boosting customer lifetime value, or reducing churn. Our strategic approach ensures every campaign moves the needle where it matters most.</p>
                </div>
            </div>
          </div>
        </section>
      </div>

      {/*** Vision ***/}
      <div className="w-full relative overflow-hidden bg-[#e7e7e7] z-10">
        <section className="pt-12">
          <div className="container z-10">
            <div className="max-w-[1100px] mx-auto items-end md:flex md:justify-between">
                <div className="relative w-full md:w-[50%] block rounded-lg mb-6 md:mb-0">
                  <h2 className="text-3xl mb-4 font-bold font-[Antonio] text-disruptive-red md:text-5xl">VISION:</h2>
                  <p className="font-bold uppercase text-lg md:text-2xl mb-4 max-w-md">MOST BUSINESSES DON’T HAVE A CLEAR VISION, WHICH PREVENTS GREAT STRATEGY AND EXECUTION</p>
                  <p className="mb-8 max-w-md">If you’re unsure of what success looks like for your lifecycle marketing, it’s impossible to build campaigns that get you there. Without a clear vision, your marketing becomes reactive instead of proactive, leading to short-term fixes instead of long-term growth.</p>
                  <p className="mb-8 max-w-md">We help you define what winning looks like. Whether it’s a 20% increase in retention, a higher conversion rate from email, or doubling your SMS revenue, we set clear, measurable goals and build a lifecycle marketing system that works toward them.</p>
                  <Button
                    className={`rounded-full uppercase overflow-hidden bg-disruptive-red text-white border-2 border-disruptive-red mb-8 text-center font-bold xs:tracking-normal hover:bg-transparent hover:text-disruptive-red`}
                    href={'#lead-form'}
                    color={""}
                    bordered={false}
                  >
                    Get Your Audit To Find Out Where You’re Stuck
                  </Button>
                </div>
                <div className="relative w-full md:w-[50%]">
                  <GatsbyImage
                      className={`relative`}
                      image={binosHandGet}
                      alt="binoculars"
                  />
                </div>
            </div>
          </div>
        </section>
      </div>

      {/*** How our agency can help ***/}
      <div className="w-full relative overflow-hidden bg-black">
        <section className="py-14">
          <div className="container z-10">
            <h2 className="text-3xl mb-14 font-bold font-[Antonio] mx-auto text-center text-white max-w-[700px] md:text-5xl">HOW OUR LIFECYCLE MARKETING SERVICES CAN HELP</h2>
            <div className="max-w-[1100px] mx-auto md:flex items-stretch md:justify-between">
              <div className={String.raw`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 rounded-b-[25px] md:w-[31%] md:mb-0`}>
                <GatsbyImage
                    className={`relative mb-4 w-full`}
                    image={laptopHandsGet}
                    alt="laptop"
                />
                <h3 className="font-[Antonio] text-xl flex-none mx-5 mb-3 md:text-3xl">DO IT YOURSELF</h3>
                <p className="mb-4 grow mx-5">Are you struggling to get real results from your email or SMS marketing campaigns? Our no-cost lifecycle marketing audit takes the guesswork out of your strategy. We’ll analyze your current performance, identify gaps, and provide a clear action plan to improve engagement, increase conversions, and drive revenue.</p>
                <Button
                  className={`rounded-full overflow-hidden bg-disruptive-red text-white border-2 border-disruptive-red text-center font-bold flex-none mx-5 xs:tracking-normal hover:bg-transparent hover:text-disruptive-red`}
                  href={'#lead-form'}
                  color={""}
                  bordered={false}
                >
                  GET YOUR AUDIT
                </Button>
              </div>
              <div className={String.raw`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 rounded-b-[25px] md:w-[31%] md:mb-0`}>
                <GatsbyImage
                    className={`relative mb-4 w-full`}
                    image={shakingHandsGet}
                    alt="handshake"
                />
                <h3 className="font-[Antonio] text-xl flex-none mx-5 mb-3 md:text-3xl">DO IT WITH US</h3>
                <p className="mb-4 grow mx-5">Not sure where to start? Our lifecycle marketing agency provides proven frameworks, audience segmentation strategies, and hands-on guidance to help you optimize your customer journey. We’ll work with you to refine your messaging, automate touchpoints, and create campaigns that nurture leads and turn them into loyal customers.</p>
                <Button
                  className={`rounded-full overflow-hidden bg-disruptive-red text-white border-2 border-disruptive-red text-center font-bold flex-none mx-5 xs:tracking-normal hover:bg-transparent hover:text-disruptive-red`}
                  href={'#lead-form'}
                  color={""}
                  bordered={false}
                >
                  GET PLAYBOOK
                </Button>
              </div>
              <div className={String.raw`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 rounded-b-[25px] md:w-[31%] md:mb-0`}>
                <GatsbyImage
                    className={`relative mb-4 w-full`}
                    image={modernWorkplaceGet}
                    alt="modern workplace"
                />
                <h3 className="font-[Antonio] text-xl flex-none mx-5 mb-3 md:text-3xl">DONE FOR YOU</h3>
                <p className="mb-4 flex-none mx-5">As a full-service agency, we handle everything — from email and SMS automation to retargeting and audience segmentation — so you can focus on running your business. We build and execute campaigns designed to maximize customer lifetime value and keep your brand top of mind.</p>
                <p className="mb-8 grow mx-5 font-bold">If we don’t improve your engagement and revenue in 90 days, you don’t pay.</p>
                <Button
                  className={`rounded-full overflow-hidden bg-disruptive-red text-white border-2 border-disruptive-red text-center font-bold flex-none mx-5 xs:tracking-normal hover:bg-transparent hover:text-disruptive-red`}
                  href={'#lead-form'}
                  color={""}
                  bordered={false}
                >
                  BOOK A CALL
                </Button>
              </div>               
            </div>
          </div>
        </section>
      </div>

      {/*** PPC Agency that gets you ***/}
      <div className="w-full relative overflow-hidden bg-white">
        <section className="py-14">
          <div className="container z-10">
            <div className="max-w-[670px] mx-auto">
              <h2 className="text-3xl mb-6 font-bold font-[Antonio] mx-auto text-center md:text-5xl">A LIFECYCLE MARKETING AGENCY THAT GIVES YOU MORE</h2>
              <GatsbyImage
                className={`relative mb-4 w-full`}
                image={clutchBadgesGet}
                alt="Clutch badges"
              />
              <p className="mb-4">Most businesses chase new customers, pouring time and money into acquisition while overlooking the real goldmine: the customers they already have.</p>
              <p className="mb-4">We help businesses stop leaving money on the table by turning one-time buyers into lifelong customers. With the right lead nurture strategy, you get more revenue, loyalty, and growth at a fraction of the cost. Companies that invest in smart automation see a massive boost in qualified leads, lower acquisition costs, and stronger customer retention.</p>
              <p className="mb-4">If you‘re ready to stop spinning your wheels chasing cold leads and start building a marketing strategy that actually compounds over time, we’re here to help.</p>
              <div className="mx-auto mb-8 md:flex items-stretch md:justify-between">
                <div className={`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 rounded-b-[25px] md:w-[48%] md:mb-0`}>
                    <p className="font-[Antonio] p-2 text-center mb-4 text-lg bg-black text-white">CASE STUDY</p>
                    <h3 className="text-center text-xl flex-none mx-5 font-bold mb-4 md:text-2xl">NANI SWIMWEAR:<span className="block text-disruptive-red">+286% Email Revenue Conversions</span></h3>
                    <p className="mb-5 flex-none mx-5">Emails were in place, but subscriber growth was slow and email engagement wasn’t where it needed to be. We established content hierarchy with a personalized experience.</p>
                    <p className="mb-6 grow mx-5">Year over year analysis shows email revenue conversions increased by 285.7% and now contributes to 11.5% of website sales.</p>
                    <a
                    className={`group relative inline-block py-3 px-5 text-base font-semibold uppercase leading-4 tracking-normal transition-all duration-300 ease-in-out md:py-[21px] md:px-[30px] rounded-full overflow-hidden bg-[transparent] border-2 border-black text-center font-bold flex-none mx-5 tracking-normal hover:bg-black hover:text-[#e7e7e7]`}
                    href={naniCS}
                    target="_blank"
                    rel="noreferrer"
                    >
                    <span className="relative transition-colors duration-300 ease-in-out ">Full Story</span>
                    </a>
                </div>
                <div className={`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 rounded-b-[25px] md:w-[48%] md:mb-0`}>
                    <p className="font-[Antonio] p-2 text-center mb-4 text-lg bg-black text-white">CASE STUDY</p>
                    <h3 className="text-center text-xl flex-none mx-5 font-bold mb-4 md:text-2xl">USA CLEAN:<span className="block text-disruptive-red">38% YOY Growth</span></h3>
                    <p className="mb-6 grow mx-5">The challenge before us was how to re-organize a feed with thousands of products. We scaled additional spend towards the most profitable products and increase revenue using lifecycle marketing along with YouTube Ads.</p>
                    <a
                    className={`group relative inline-block py-3 px-5 text-base font-semibold uppercase leading-4 tracking-normal transition-all duration-300 ease-in-out md:py-[21px] md:px-[30px] rounded-full overflow-hidden bg-[transparent] border-2 border-black text-center font-bold flex-none mx-5 tracking-normal hover:bg-black hover:text-[#e7e7e7]`}
                    href={usacleanCS}
                    target="_blank"
                    rel="noreferrer"
                    >
                    <span className="relative transition-colors duration-300 ease-in-out ">Full Story</span>
                    </a>
                </div>              
              </div>
              <div className="bg-[#e7e7e7] p-6 rounded-[25px]">
                <h3 className="font-[Antonio] text-xl text-center flex-none mx-5 mb-6 md:text-3xl">BUSINESSES WHO COME TO US FOR THEIR <span className="text-disruptive-red">LCM MARKETING SERVICES</span> ALSO WANT HELP WITH:</h3>
                <div className="mx-auto flex items-center justify-center flex-wrap gap-3">
                    <Link 
                        to="/advertising-services/ppc-management/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${greyLaptopHandsGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">PAID SEARCH</span></Link>
                    <Link 
                        to="/social-media-advertising/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${greyLaptopUiGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">PAID SOCIAL</span></Link>
                    <Link 
                        to="/lead-generation-services/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${handsPhoneGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">LEAD<br/>GENERATION</span></Link>
                    <Link 
                        to="/ecommerce-marketing-agency/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${greyPhoneUserGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">ECOMMERCE</span></Link>
                    <Link 
                        to="/seo-services/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${greyLaptopCreditCardGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">SEO</span></Link>
                    <Link 
                        to="/amazon-marketing-services/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${greyWorkersGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">AMAZON</span></Link>
                    <Link 
                        to="/creative-services/"
                        className="relative text-center text-white font-bold w-full flex items-center justify-center p-2 min-h-[125px] before:transition-all before:duration-400 before:ease-in-out before:absolute before:top-0 before:left-0 before:bg-[rgba(0,0,0,.4)] before:w-full before:bottom-0 before:z-10 hover:before:bg-[rgba(0,0,0,.6)] sm:w-[48%] md:w-[23%]"
                        style={{
                        backgroundImage: `url(${greyMonitorGet.images.fallback.src})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        }}
                    ><span className="relative z-20">CREATIVE</span></Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/*** How our agency can help ***/}
      <div className="w-full relative overflow-hidden bg-black">
        <section className="py-14">
          <div className="container z-10">
            <h2 className="text-3xl mb-14 font-bold font-[Antonio] mx-auto text-center text-white md:text-5xl">CHECK OUT OUR LATEST POSTS ON LIFECYCLE MARKETING</h2>
            <div className="max-w-[1100px] mx-auto mb-16 md:flex items-stretch md:justify-between">
              <div className={`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 md:w-[31%] md:mb-0`}>
                <img
                    className={`relative mb-4 w-full max-h-[160px] object-cover grayscale`}
                    src="https://wp.disruptiveadvertising.com/wp-content/uploads/2022/05/image1-1.jpg"
                    alt="local business"
                />
                <h3 className="text-xl font-bold grow mx-5 mb-8 md:text-2xl">What is Customer Lifecycle Marketing?</h3>
                <Button
                  className={`rounded-full overflow-hidden bg-black text-white border-2 border-black text-center font-bold flex-none mx-5 xs:tracking-normal hover:bg-transparent hover:text-black`}
                  href={'https://disruptiveadvertising.com/blog/marketing/what-is-customer-lifecycle-marketing/'}
                  color={""}
                  bordered={false}
                >
                  READ BLOG
                </Button>
              </div>
              <div className={`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 md:w-[31%] md:mb-0`}>
                <img
                    className={`relative mb-4 w-full max-h-[160px] object-cover grayscale`}
                    src="https://wp.disruptiveadvertising.com/wp-content/uploads/2023/12/how-to-identify-customer-paint-points-featured-image.jpg"
                    alt="Ads UI"
                />
                <h3 className="text-xl font-bold grow mx-5 mb-8 md:text-2xl">How to Identify Customer Pain Points</h3>
                <Button
                  className={`rounded-full overflow-hidden bg-black text-white border-2 border-black text-center font-bold flex-none mx-5 xs:tracking-normal hover:bg-transparent hover:text-black`}
                  href={'https://disruptiveadvertising.com/blog/marketing/how-to-identify-customer-pain-points/'}
                  color={""}
                  bordered={false}
                >
                  READ BLOG
                </Button>
              </div>
              <div className={`relative w-full flex flex-col mb-12 bg-[#e7e7e7] pb-6 md:w-[31%] md:mb-0`}>
                <img
                    className={`relative mb-4 w-full max-h-[160px] object-cover grayscale`}
                    src="https://wp.disruptiveadvertising.com/wp-content/uploads/2023/08/10-benefits-of-email-marketing-featured-image.jpg"
                    alt="Ads UI"
                />
                <h3 className="text-xl font-bold grow mx-5 mb-8 md:text-2xl">The 10 Benefits of Email Marketing | You Need Email</h3>
                <Button
                  className={`rounded-full overflow-hidden bg-black text-white border-2 border-black text-center font-bold flex-none mx-5 xs:tracking-normal hover:bg-transparent hover:text-black`}
                  href={'https://disruptiveadvertising.com/blog/email-marketing/10-benefits-of-email-marketing/'}
                  color={""}
                  bordered={false}
                >
                  READ BLOG
                </Button>
              </div>               
            </div>
            <div className="w-full text-center">
              <Button
                className={`rounded-full overflow-hidden bg-disruptive-red text-white border-2 border-disruptive-red text-center font-bold flex-none xs:tracking-normal hover:bg-transparent hover:text-disruptive-red`}
                href={'#lead-form'}
                color={""}
                bordered={false}
              >
                GET YOUR FREE AUDIT
              </Button>
            </div>
          </div>
        </section>
      </div>

      {/*** LP FOOTER
      <div className="w-full relative overflow-hidden bg-white">
        <section className="py-12">
          <div className="container z-10">
            <p className="text-center">Disruptive Advertising All Rights Reserved &copy; {currentYear}. <Link to="/privacy-policy/" className="underline">Privacy Policy</Link></p>
          </div>
        </section>
      </div>
      ***/}

      {/*** BASE SECTION WRAPPER 
      <div className="w-full relative overflow-hidden bg-black">
        <section className="pt-12 pb-4 md:pt-24 md:pb-8">
          <div className="container z-10">
            <div className="md:flex md:items-start md:justify-between">

            </div>
          </div>
        </section>
      </div>
      ***/}
      
      {/*** BLOG POSTS
      {featuredPosts?.edges?.length && (
        <div className="w-full relative overflow-hidden bg-white">
          <section className="py-16 md:py-24">
              <div className="container z-10">
                <h2 className="md:text-5xl text-3xl mb-6 font-bold max-w-[1100px] mx-auto">While you’re waiting for our phone call...</h2>
                <p className="md:text-2xl text-xl mb-12 max-w-[1100px] mx-auto">Want some helpful marketing tips? Get a wealth of up to date industry insights from our blog. We won’t be offended if you take all the credit!</p>
                <div className="md:flex md:items-center md:justify-center gap-6 mt-12">
                  
                  {featuredPosts.edges.map(
                    ({ node: { featuredImage }, node: { title }, node: { uri }, node: { excerpt } }, index) => {
                      // remove html tags from excerpt
                      excerpt = excerpt.replace(/(<([^>]+)>)/gi, "");
                      // remove the [&hellip;] from excerpt
                      excerpt = excerpt.replace("[&hellip;]", "");
                      const thumbnail = getImage(featuredImage?.node?.localFile);

                      return (
                        <div key={`featured-post-` + index} className={`md:mb-0 ${index != 2 ? 'mb-12' : ''}`}>
                          <article className="max-w-[350px] mx-auto">
                            <BaseLink href={uri}>
                              {featuredImage?.node && (
                                <GatsbyImage
                                  className={``}
                                  image={thumbnail}
                                  alt={
                                    featuredImage?.node?.altText
                                      ? featuredImage.node.altText
                                      : ""
                                  }
                                />
                              )}
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 4" fill="none" className="mx-auto w-[100%] h-15px -mt-[2px]">
                                  <path d="M0 2H100" stroke="url(#paint0_linear_22_1779)" strokeWidth="3"/>
                                  <defs>
                                    <linearGradient id="paint0_linear_22_1779" x1="0" y1="2" x2="100" y2="2.00009" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#DA2128"/>
                                        <stop offset="1" stopColor="#800507"/>
                                    </linearGradient>
                                  </defs>
                              </svg>
                              <h3 className="mt-7 mb-5 text-xl font-bold line-clamp-3 md:text-3xl">
                                {title}
                              </h3>
                              {excerpt && (
                                <div
                                  className=" md:mb-8 mb-6 line-clamp-2"
                                  dangerouslySetInnerHTML={{ __html: excerpt }}
                                ></div>
                              )}
                              <p className="font-semibold uppercase tracking-widest">
                                Read More{" "}
                              </p>
                            </BaseLink>
                          </article>
                        </div>
                      );
                    }
                  )}

                </div>
              </div>
          </section>
        </div>
      )}
      ***/}

      {/*** FOOTER BG ***/}
      <style dangerouslySetInnerHTML={{__html: footerBg}} />
    </Layout>
  );
}

LcmVertical.propTypes = {
  data: PropTypes.any,
};

export const query = graphql`
  query page($id: String!) {
    wpPage(id: { eq: $id }) {
      footerCta {
        enableCallToAction
        callToAction {
          title
          text
          button {
            link
            label
          }
        }
      }
      id
      title
      status
      slug
      content
      date(formatString: "MMMM D, YYYY")
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 783, layout: CONSTRAINED, quality: 85)
            }
          }
        }
      }

      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
    logoImage: file(relativePath: { eq: "da-white-logo.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    heroImage: file(relativePath: { eq: "verticals/da-group-circle.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    maze: file(relativePath: { eq: "verticals/maze.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    chessPieces: file(relativePath: { eq: "verticals/chessPieces.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    binosHand: file(relativePath: { eq: "verticals/binosHand.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    laptopHands: file(relativePath: { eq: "verticals/laptopHands.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    shakingHands: file(relativePath: { eq: "verticals/shakingHands.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    modernWorkplace: file(relativePath: { eq: "verticals/modernWorkplace.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    clutchBadges: file(relativePath: { eq: "verticals/clutchBadges.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    greyLaptopCreditCard: file(relativePath: { eq: "verticals/greyLaptopCreditCard.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    greyLaptopHands: file(relativePath: { eq: "verticals/greyLaptopHands.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    greyLaptopUi: file(relativePath: { eq: "verticals/greyLaptopUi.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    greyMonitor: file(relativePath: { eq: "verticals/greyMonitor.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    greyWorkers: file(relativePath: { eq: "verticals/greyWorkers.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    handsPhone: file(relativePath: { eq: "verticals/handsPhone.jpeg" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    socialProofBanner: file(relativePath: { eq: "verticals/socialProofBanner.png" }) {
      childImageSharp {
        gatsbyImageData(quality: 85)
      }
    }
    lewisTestimonial: file(relativePath: { eq: "verticals/treyTestimonial.png"}) {
        childImageSharp {
            gatsbyImageData(quality: 85)
        }
    }
    reviewer: file(relativePath: { eq: "verticals/reviewer-9.png"}) {
        childImageSharp {
            gatsbyImageData(quality: 85)
        }
    }
    reviewer2: file(relativePath: { eq: "verticals/reviewer-3.png"}) {
        childImageSharp {
            gatsbyImageData(quality: 85)
        }
    }
    reviewer3: file(relativePath: { eq: "verticals/reviewer-4.png"}) {
        childImageSharp {
            gatsbyImageData(quality: 85)
        }
    }
    greyPhoneUser: file(relativePath: { eq: "verticals/greyPhoneUser.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 85)
        }
    }
    greyAnalytics: file(relativePath: { eq: "verticals/greyAnalytics.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 85)
        }
    }
  }
`;